// import CtaBanner from '@rsa-digital/evo-shared-components/components/CtaBanner';
import { generateKeyForElement } from '@rsa-digital/evo-shared-components/helpers/elementKeyHelper';
import { graphql } from 'gatsby';
import React from 'react';
import { processOptionalCta } from 'helpers/csTypeProcessors';
import { CsCta } from 'types/contentStack';
import { StyledCtaBanner } from './styles';

export type CtaBannersBlockProps = {
  cta_banners: {
    primary_cta: [CsCta] | null;
    secondary_cta: [CsCta] | null;
    heading: string;
    subheading: string | null;
  }[];
};

export const query = graphql`
  fragment CtaBannersBlock on cs__cta_banners {
    cta_banners {
      primary_cta {
        ...Cta
      }
      secondary_cta {
        ...Cta
      }
      heading
      subheading
    }
  }
`;

const CtaBannersBlock: React.FC<{
  cta_banners: CtaBannersBlockProps;
}> = ({ cta_banners }) => (
  <>
    {cta_banners.cta_banners.map((entry, index) => (
      <StyledCtaBanner
        className="ctaBanner"
        key={generateKeyForElement(entry)}
        data-cy={`CtaBanner${index}`}
        primaryCta={processOptionalCta(entry.primary_cta, 'CtaBannerPrimaryCta')}
        secondaryCta={processOptionalCta(entry.secondary_cta, 'CtaBannerSecondaryCta')}
        heading={entry.heading}
        subheading={entry.subheading ?? undefined}
      />
    ))}
  </>
);

export default React.memo(CtaBannersBlock);
